import axios from '../utils/axios';

export default function downloadCompetitionData(adminId, params) {
    
    return (
        axios.get('/admin/'+adminId + '/competition/user/admin/competition-listing-download', { params, responseType: 'blob' })
    )
}
